<template>
  <div class="bg-white rounded-lg shadow overflow-hidden p-3 h-full flex flex-col transition-all hover:shadow-md">
    <!-- Compact header with rating + quote mark side by side -->
    <div class="flex justify-between items-center mb-1">
      <div class="flex">
        <svg v-for="star in testimonial.rating" :key="star" class="w-4 h-4 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      </div>
      <div class="text-gray-300 text-3xl font-serif leading-none">"</div>
    </div>

    <!-- Testimonial content -->
    <p class="text-gray-600 text-sm flex-grow mb-3 line-clamp-4">{{ testimonial.text }}</p>

    <!-- User info -->
    <div class="flex items-center mt-auto">
      <div class="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
        <img
            :src="testimonial.avatar"
            :alt="testimonial.name"
            class="w-full h-full object-cover"
            @error="handleAvatarError"
        />
      </div>
      <div class="ml-2 overflow-hidden">
        <h4 class="font-medium text-xs text-gray-900 truncate">{{ testimonial.name }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialCard',
  props: {
    testimonial: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleAvatarError(e) {
      // Replace with default avatar if image fails to load
      e.target.src = '/images/avatars/default-avatar.png';
    }
  }
}
</script>